import { type } from "jquery";
import * as yup from "yup";
export const schema = [
  yup.object({
    // typeCasualty: yup.string()
    // .required('Type of Casualty is required')
    // .oneOf(["0", "1"], "Invalid type of casualty"), // Ensure it's either "Death" (0) or "Injured" (1)
  
  nameDeceased: yup.string()
    .required('Name of Deceased/Injured person is required')
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be at most 100 characters'), // Optional: You can set limits on the length of name
    
    fathersName: yup.string()
    .required(`Father's Name/ Husband's Name is required`)
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be at most 100 characters'), // Optional: You can set limits on the length

    occupation: yup.string()
    .required(`Occupation is required`)
    .min(1, 'Must be at least 1 characters')
    .max(100, 'Name must be at most 100 characters'), 

    // age: Validation for the age field
    age: yup
  .string()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue === null || originalValue === undefined) {
      return null;
    }
    return originalValue.toString().trim();
  })
  .required('Age is required')
  .max(60, 'Age must be 60 characters or less')
  .matches(
    /^[a-zA-Z0-9.\s]+$/,
    'Age can only contain letters, numbers, spaces, and decimal points'
  )
  .test(
    'valid-age-format',
    'Please enter a valid age (e.g., "25", "2.5 years", "6.25 months")',
    function (value) {
      if (!value) return true;

      const trimmed = value.trim();

      // Allow numeric-only values like "25" or "2.5" with up to 2 decimal places
      if (/^\d+(\.\d{1,2})?$/.test(trimmed)) {
        const numericValue = parseFloat(trimmed);
        return numericValue > 0 && numericValue <= 120;
      }

      // Allow formats like "2.5 years", "1.25 months", "2.5 years 1.5 months", etc.
      const agePattern =
        /^(\d+(\.\d{1,2})?)\s*(year|years|yr|yrs|month|months|mo|mos|week|weeks|wk|wks|day|days)?(\s+(\d+(\.\d{1,2})?)\s*(month|months|mo|mos|day|days|week|weeks|wk|wks))?$/i;

      return agePattern.test(trimmed);
    }
  ),


      // hospitalName: yup
      // .string()
      // .when("hospitalized", {
      //   is: (hospitalized) => hospitalized === "True", // Only validate when hospitalized is "True"
      //   then: yup
      //     .string()
      //     .required("Hospital Name is required")
      //     .min(2, 'Hospital Name must be at least 2 characters long')
      //     .max(200, 'Hospital Name must be at most 200 characters long')
      //     .matches(/^[a-zA-Z0-9\s]*$/, 'Hospital Name can only contain letters, numbers, and spaces'),
      //   otherwise: yup.string().notRequired(), // No validation if hospitalized is "False"
      // }),
   
    reportedPoliceStation: yup.string().required("Reported to police station is required"),

    policeStationName: yup
      .string()
      .nullable()  // Allows null when not required
      .when("reportedPoliceStation", {
        is: "True",  // Only when 'Yes' is selected
        then: yup.string().required("Police station name is required"),  // Make it required when "Yes"
        otherwise: yup.string().nullable(),  // Allow null when "No"
      }),

      postMortem: yup
  .string()
  .nullable()
  .when("typeCasualty", {
    is: "0", // Only required if typeCasualty is "Death"
    then: yup
      .string()
      .required("Post mortem selection is required for death cases")
      .oneOf(["True", "False"], "Invalid selection for Post Mortem"),
    otherwise: yup.string().nullable(), // Optional for other cases
  }),

  entryDate: yup
  .date()
  .required("Entry Date is required")
  .test(
    "is-greater-than-or-equal-to-incidentDate",
    "Entry Date must be greater than or equal to Incident Date",
    function (value) {
      // Access the incidentDate from the parent context
      const incidentDate = this.parent.incidentDate;

      // Log the values for debugging
      console.log("entryDate (raw):", value);
      console.log("incidentDate (raw):", incidentDate);

      // If either date is missing, skip validation
      if (!value || !incidentDate) return true;

      // Strip time component from both dates
      const entryDateWithoutTime = new Date(value).setHours(0, 0, 0, 0);
      const incidentDateWithoutTime = new Date(incidentDate).setHours(0, 0, 0, 0);

      // Log the stripped dates for debugging
      console.log("entryDate (stripped):", new Date(entryDateWithoutTime));
      console.log("incidentDate (stripped):", new Date(incidentDateWithoutTime));

      // Compare the dates using >= (greater than or equal to)
      const isValid = entryDateWithoutTime >= incidentDateWithoutTime;
      console.log("Validation result:", isValid);
      return isValid;
    }
  ),

      paymentDate: yup.string()
      .when(['paymentStatus', 'entryDate'], {
        is: (paymentStatus, entryDate) => paymentStatus === "0" && entryDate, // Only validate when payment status is "Yes" and entryDate exists
        then: () => yup.string()
          .required('Payment Date is required when Payment Status is Yes')
          .test('date-comparison', 
            'Payment Date must be equal to or greater than Entry Date', 
            function(value) {
              const entryDate = this.parent.entryDate;
              if (!value || !entryDate) return true; // Skip validation if either date is missing
              
              // Convert both dates to timestamps for comparison
              const paymentTimestamp = new Date(value).getTime();
              const entryTimestamp = new Date(entryDate).getTime();
              
              return paymentTimestamp >= entryTimestamp;
            }
          ),
        otherwise: () => yup.string()
          .test('no-date-if-not-yes', 
            'Payment Date can only be selected when Payment Status is Yes', 
            function(value) {
              // If there's a date value and status is not "Yes", return error
              if (value && value.trim() !== '') {
                return false;
              }
              return true;
            }
          )
      })
  }),
];

export const PrimaryConfigSchema = [
  yup.object({
    Latitude: yup
  .string()
  .transform((value, originalValue) => String(originalValue))
  .when('nameOfDisaster', {
    is: 'Lightning',
    then: () => yup.string()
      .required("Latitude is required for Lightning incidents")
      .matches(
        /^-?\d+(\.\d+)?$/, // Regex to match numbers, including decimals and negative numbers
        "Latitude must be a valid number"
      )
  }),

longitude: yup
  .string()
  .transform((value, originalValue) => String(originalValue))
  .when('nameOfDisaster', {
    is: 'Lightning',
    then: () => yup.string()
      .required("Longitude is required for Lightning incidents")
      .matches(
        /^-?\d+(\.\d+)?$/, // Regex to match numbers, including decimals and negative numbers
        "Longitude must be a valid number"
      )
  }),

  numberOfDeaths: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? NaN : Number(originalValue);
      })
      .required("Number of Deaths is required")
      .typeError("Number of Deaths must be a number")
      .min(0, "Number of Deaths cannot be negative")
      .test(
        'not-less-than-actual-deaths',
        'Number of deaths less than the detailed entries',
        function(value) {
          const { options } = this;
          const actualDeathCount = options.context?.actualDeathCount || 0;
          return value >= actualDeathCount;
        }
      ),

    numberOfInjured: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? NaN : Number(originalValue);
      })
      .required("Number of Injured is required")
      .typeError("Number of Injured must be a number")
      .min(0, "Number of Injured cannot be negative")
      .test(
        'not-less-than-actual-injured',
        'Number of injured less than the detailed entries',
        function(value) {
          const { options } = this;
          const actualInjuredCount = options.context?.actualInjuredCount || 0;
          return value >= actualInjuredCount;
        }
      ),
  }),
];


export const HumanLossPrimaryConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "date",
        label: "Date",
        type: "input",
        style: { width: "200px" },
        disabled: true
      },
      {
        name: "nameOfDistrict",
        label: "District",
        type: "input",
        style: { width: "340px" },
        disabled: true
      },
      {
        name: "block",
        label: "Block",
        type: "input",
        style: { width: "280px" },
        disabled: true
      },
      {
        name: "nameOfDisaster",
        label: "Name of disaster",
        type: "input",
        style: { width: "340px" },
        disabled: true
      },
      {
        name: "incidentId",
        label: "Incident Id",
        type: "input",
        style: { width: "340px" },
        disabled: true
      },
      {
        name: "incidentDate",
        label: "Incident date",
        type: "date",
        style: { width: "200px" },
        disabled: true
      },
      {
        name: "incidentTime",
        label: "Incident time",
        type: "input",
        style: { width: "340px" },
        disabled: true
      },
      {
        name: "numberOfDeaths",
        label: "Number of casualty (Death) as per primary information",
        type: "input",
        style: { width: "340px" },
        mandatory: "true",
      },
      {
        name: "numberOfInjured",
        label: "Number of casualty (Injured) as per primary information",
        type: "input",
        style: { width: "280px" },
        mandatory: "true",
      },
      {
        name: "Latitude",
        label: "Latitude",
        type: "input",
        style: { width: "340px" },
        mandatory: (values) => values.nameOfDisaster === 'Lightning'
        // mandatory: "true",
        // validation: yup
        //   .string()
        //   .when("nameOfDisaster", {
        //     is: "Lightning",
        //     then: yup.string().required("Latitude is required"),
        //     otherwise: yup.string().notRequired(),
        //   }),
      },
      {
        name: "longitude",
        label: "Longitude",
        type: "input",
        style: { width: "340px" },
        mandatory: (values) => values.nameOfDisaster === 'Lightning'
        // mandatory: "true",
        // validation: yup
        //   .string()
        //   .when("nameOfDisaster", {
        //     is: "Lightning",
        //     then: yup.string().required("Longitude is required"),
        //     otherwise: yup.string().notRequired(),
        //   }),
      },
      {
        name: "policeStationOfIncident",
        label: "Police station of incident",
        type: "single_select",
        options: [
          { value: "0", label: "Bhargawan" },
          { value: "1", label: "Bihia" },
        ],
        style: { width: "280px" }
        // mandatory: "true",
      },
      {
        name: "addressOfIncident",
        label: "Address of incident",
        type: "input",
        style: { width: "340px" },
        // mandatory: "true",
        maxLength: null
      },
      

    ],
  },
];

export const HumanLossUserConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "typeCasualty",
        label: "Type of casualty",
        type: "select",
        options: [
              { value: "0", label: "Death" },
              { value: "1", label: "Injured" },
            ],
        mandatory: "true",
      },
      {
        name: "nameDeceased",
        label: "Name of deceased/ injured person",
        type: "input",
        mandatory: "true",
      },
      {
        name: "age",
        label: "Age",
        type: "input",
        mandatory: "true",
      },
      {
        name: "sex",
        label: "Gender",
        type: "select",
        options: [
          { value: "0", label: "Male" },
          { value: "1", label: "Female" },
          { value: "2", label: "Transgender" },
        ],
        mandatory: "true",
      },
      {
        name: "fathersName",
        label: "Father's name/ husband's name",
        type: "input",
        mandatory: "true",
      },
      {
        name: "residentialAddress",
        label: "Residential address of deceased person/ injured person",
        type: "input",
        maxLength: null
      },
      {
        name: "activityAccident",
        label: "Victim's activity during accident",
        type: "input",
        maxLength: 200
      },
      {
        name: "postMortem",
        label: "Post mortem done",
        type: "select",
        options: [
          { value: "True", label: "Yes" },
          { value: "False", label: "No" },
        ],
        // mandatory: "true",
      },
      {
        name: "occupation",
        label: "Occupation",
        type: "input",
        mandatory: "true"
      },
      {
        name: "death_due_to_heatstroke_has_been_certified",
        label: "Whether the death due to heatstroke has been certified by the competent authority/doctor",
        type: "select",
        options: [
          { value: "True", label: "Yes" },
          { value: "False", label: "No" },
        ],
        mandatory: "true"
      },
      
      {
        name: "hospitalized",
        label: "Hospitalized",
        type: "select",
        options: [
          { value: "True", label: "Yes" },
          { value: "False", label: "No" },
        ],
        mandatory: "true",
      },
      {
        name: "hospitalName",
        label: "Hospital name",
        type: "input",
        // mandatory: "true",
        maxLength: null
      },
      {
        name: "reportedPoliceStation",
        label: "Reported to police station",
        type: "select",
        options: [
          { value: "True", label: "Yes" },
          { value: "False", label: "No" },
        ],
        mandatory: "true",
      },
      {
        name: "policeStationName",
        label: "Police station name",
        type: "single_select",
        options: [
          { value: "0", label: "Bhargawan" },
          { value: "1", label: "Bihia" },
        ],
        mandatory: "true",
      },
      
      {
        name: "entryDate",
        label: "Entry date",
        type: "date",
        mandatory: "true",
      },
      {
        name: "paymentStatus",
        label: "Payment status (Yes / No)",
        type: "select",
        options: [
          { value: "0", label: "Yes" },
          { value: "1", label: "No" },
          { value: "2", label: "NA" },
        ],
        mandatory: (values) => values.nameOfDisaster !== 'Road Accident', // Only mandatory if not Road Accident
      },
      {
        name: "paymentDate",
        label: "Payment date",
        type: "date",
        mandatory: (values) => values.paymentStatus === "0" && values.nameOfDisaster !== 'Road Accident', 
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "text_area",
      },















      // {
      //   name: "task_type",
      //   label: "taskmgmntformlabels.tasktype",
      //   type: "select",
      //   options: [
      //     { value: "0", label: "Activity" },
      //     { value: "1", label: "Notification" },
      //   ],
      // },
      // {
      //   name: "assign_type",
      //   label: "taskmgmntformlabels.assigntype",
      //   type: "select",
      //   options: [
      //     { value: "0", label: "Group" },
      //     { value: "1", label: "Individual" },
      //   ],
      // },
      // {
      //   name: "role_list",
      //   label: "taskmgmntformlabels.rolelist",
      //   type: "multi_select",
      //   mandatory: "true",
      // },
      // {
      //   name: "user_list",
      //   label: "taskmgmntformlabels.userlist",
      //   type: "multi_select",
      //   mandatory: "true"
      // },

      // {
      //   name: "description",
      //   label: "taskmgmntformlabels.summary",
      //   type: "text_area",
      // },
    ],
  },
];
